import React from "react";
import { Container, Carousel, Image } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";


const cow = "https://d2lptvt2jijg6f.cloudfront.net/jspsteelpower20/custom/1737826622cow.png";
const campaing = "https://d2lptvt2jijg6f.cloudfront.net/jspsteelpower20/custom/1737826622campaing.png";
const mom = "https://d2lptvt2jijg6f.cloudfront.net/jspsteelpower20/custom/1737826622mom.png";

const MakingHeadlines = () => {
  const testimonials = [
    {
      role: (
        <span className="cus_text20">
          "The Steel of India" campaign by Jindal Steel stands as a testament to
          the nation’s spirit, encapsulating the essence of India’s resilience,
          progress, and cultural richness."
        </span>
      ),
      imageSrc: cow,
      link: "https://campaignsoftheworld.com/tv/the-steel-of-india/",
    },
    {
      role: (
        <span className="cus_text20">
          "With stunning visuals and a toe-tapping soundtrack to boot, the
          creative campaign roped in industry icons Ayappa K.M., Bharat Sikka,
          and Sneha Khanwalkar to bring the brand vision to life."
        </span>
      ),
      imageSrc: campaing,
      link: "https://www.campaignindia.in/video/jindal-steel-celebrates-the-grit-of-india-in-new-campaign/494986",
    },
    {
      role: (
        <span className="cus_text20">
          "The brand drew bold parallels between the strength of steel and the
          strength of humanity. With striking visuals, the ads were truly
          attention-grabbing."
        </span>
      ),
      imageSrc: mom,
      link: "https://mad-over-marketing.com/jindal-steel-pulled-off-a-strong-campaign-in-a-tribute-to-the-people-of-india/",
    },
  ];

  return (
    <>
      <Container>
      <div class="row">
      <div class="col-12">
        <div className="contentbox clelebrateslider">
        <h1 className="cus_text60 text-left">
          STEEL OF INDIA: MAKING HEADLINES
        </h1>
        <Carousel>
          {testimonials.map((testimonial, index) => (
            <Carousel.Item key={index}>
              <div
                className="text-center mx-auto pb-3"
                style={{ maxWidth: "800px" }}
              >
                <p className="text-muted">
                  <strong>{testimonial.role}</strong>
                </p>
                <a
                  href={testimonial.link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Image
                    src={testimonial.imageSrc}
                    alt={`Testimonial ${index + 1}`}
                    fluid
                  />
                </a>
              </div>
            </Carousel.Item>
          ))}
        </Carousel>
        </div>
        </div>
        </div>
      </Container>
    </>
  );
};

export default MakingHeadlines;
